import { UserDto } from '@linka/domain/dtos';

import { EventDto, ListResponseDto } from '../generated/data-contracts';
import { httpRequest } from '../http-client';

// Rotas REST unificadas de users (#28516). Substitui as entradas de userController do routes.ts (deprecado).
export const userController = {
  listUserEvents: httpRequest<unknown, ListResponseDto<EventDto>>('get', 'users/me/events'),
  me: httpRequest<unknown, UserDto>('get', 'users/me'),
};
